import { useMutation, useQueryClient } from '@tanstack/react-query';
import { type MutationOptions, gqlFetcher } from '../fetcher';
import { CreateIncidentLabel } from '../mutations/createIncidentLabel.mutation';
import type { CreateIncidentLabelMutation, CreateIncidentLabelMutationVariables } from '../types';

export const useCreateIncidentLabelMutation = (
  options?: MutationOptions<CreateIncidentLabelMutation, CreateIncidentLabelMutationVariables>,
) => {
  const queryClient = useQueryClient();

  return useMutation(gqlFetcher(CreateIncidentLabel), {
    ...options,
    onSettled: async (resp, error, variables, ctx) => {
      await options?.onSettled?.(resp, error, variables, ctx);

      queryClient.invalidateQueries({
        predicate: (query) => query.queryKey.includes('incident'),
      });
    },
  });
};
